import { createSelector } from 'reselect';
import { IDLE, PENDING } from 'settings/constants/apiState';

export const localState = ({ symphony }) => symphony?.symphonyList || {};

export const getStateAndDataFlag = createSelector(localState, ({ state, data }) => ({
  state,
  isIdle: state === IDLE,
  isPending: state === PENDING,
  isData: !!data,
}));

export const getSymphonyListDataArray = createSelector(localState, ({ data }) => data || []);

export const localStateStats = ({ symphony }) => symphony?.symphonyStats || {};

export const getSymphonyColumns = createSelector(localStateStats, ({ columns }) => columns);

export const getSymphonyStatsData = createSelector(localStateStats, ({ state, data, search }) => {
  const normalizedSearch = search.trim().toLowerCase();

  const filteredData =
    normalizedSearch !== ''
      ? data?.filter(({ FirstName = '', LastName = '' }) => {
          const fullName = `${FirstName} ${LastName}`.toLowerCase().trim();
          return fullName.includes(normalizedSearch);
        }) ?? []
      : data ?? [];

  return {
    state,
    isIdle: state === IDLE,
    isPending: state === PENDING,
    stats: filteredData,
  };
});

export const localStatePreferences = ({ symphony }) => symphony?.symphonyPreferences || {};

export const getSymphonyPreferencesData = createSelector(
  localStatePreferences,
  ({ state, data }) => ({
    state,
    isIdle: state === IDLE,
    isPending: state === PENDING,
    preferences: data,
  }),
);
